import API from "../../../shared/modules/API";
import axios from "axios";

export default class ProductDescriptorsAPI {
  static fetchRatings (productDescriptorId) {
    const response = axios.get(
      `/api/v${API.API_VERSION}/product_descriptors/${productDescriptorId}/ratings`,
      {
        "headers": {
          ...API.authHeaders(),
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    );

    return response;
  }

  static fetchReviews (productDescriptorId, pageQuery) {
    const response = axios.get(
      `/api/v${API.API_VERSION}/product_descriptors/${productDescriptorId}/reviews?page=${pageQuery}`,
      {
        "headers": {
          ...API.authHeaders(),
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    );

    return response;
  }

  static fetchProductPageRecommendations (forProductDescriptorId) {
    const response = axios.get(
      `/api/v${API.API_VERSION}/product_descriptors/product_page_recommendations?product_descriptor_id=${forProductDescriptorId}`, // eslint-disable-line max-len
      {
        "headers": {
          ...API.authHeaders(),
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    );

    return response;
  }
}
